import { gql } from '@/services/api';

export const UserBasicInfo = gql`
  fragment UserBasicInfo on User {
    id
    name
    nickname
    lastname
    avatar
    email
    level {
      id
      name
    }
  }
`;

export const UserMarkers = gql`
  fragment UserMarkers on User {
    markers {
      edges {
        node {
          id
          name
          category {
            id
            name
          }
          media {
            type
            source
          }
          recommendations(pagination: { first: 1 }, filters: { withMessage: true }) {
            edges {
              node {
                message
                user {
                  id
                  nickname
                  avatar
                }
              }
            }
          }
          extraInfo {
            ... on Place {
              location {
                geo {
                  lat
                  lng
                }
              }
            }
            ... on Restaurant {
              location {
                geo {
                  lat
                  lng
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const userCollectionsFragment = gql`
  fragment UserCollections on User {
    collections {
      total
      edges {
        node {
          id
          name
          description
          media {
            type
            source
          }
          owner {
            id
            level {
              id
            }
            nickname
            avatar
          }
        }
      }
    }
  }
`;

export const UserFieldsFragment = gql`
  ${UserBasicInfo}
  fragment UserFields on User {
    ...UserBasicInfo
    biography
    follows {
      total
    }
    followers {
      total
    }
    isFollowed
    isFollower
    links {
      type
      url
      name
    }
    verified
    language
    country
  }
`;

export const UserRecommendationsFragment = gql`
  fragment UserRecommendations on User {
    recommendations(pagination: { after: $after }) {
      total
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          message
          media {
            type
            source
          }
          likes {
            total
          }
          comments {
            total
          }
          user {
            id
            name
            nickname
            avatar
          }
          product {
            id
            name
            isSaved
            category {
              id
              name
            }
            media {
              type
              source
            }
          }
        }
      }
    }
  }
`;
